import { TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { FragmentTagGroupsSelector } from './FragmentTagGroupsSelector';

export function FragmentsTagInput() {
  const { $t } = useIntl();

  return (
    <TextFieldElement
      name="tags"
      label={$t({
        id: 'fragments.form.tags.label',
        defaultMessage: 'Tags',
      })}
      placeholder={$t({
        id: 'fragments.form.tags.placeholder',
        defaultMessage: 'E.g.: interview, messi, world cup, moscow',
      })}
      multiline
      fullWidth
      helperText={<FragmentTagGroupsSelector />}
      minRows={1}
      maxRows={3}
    />
  );
}
